//api.js
import requestAll from './request.js';
const api = {
    //首页
    index(data) {
        return requestAll.postRequest('/api/Content/index', data);
    },
    //关于
    about(data) {
        return requestAll.postRequest('/api/Content/about', data);
    },
    // 产品分类
    productCate(data) {
        return requestAll.postRequest('/api/Content/productCate', data);
    },
     //产品列表
     productList(data) {
        return requestAll.postRequest('/api/Content/productList', data);
    },
    //产品详情
    productDetail(data) {
        return requestAll.postRequest('/api/Content/productDetail', data);
    },
	//案例分类+BANNER
	projectCate(data) {
	    return requestAll.postRequest('/api/Content/projectCate', data);
	},
	//案例列表
	projectList(data) {
	    return requestAll.postRequest('/api/Content/projectList', data);
	},
	//案例详情
	projectDetail(data) {
	    return requestAll.postRequest('/api/Content/projectDetail', data);
	},
	//新闻分类+BANNER
	newsCate(data) {
	    return requestAll.postRequest('/api/Content/newsCate', data);
	},
	//新闻列表
	newsList(data) {
	    return requestAll.postRequest('/api/Content/newsList', data);
	},
	//新闻详情
	newsDetail(data) {
	    return requestAll.postRequest('/api/Content/newsDetail', data);
	},
	//联系我们
	contact(data) {
	    return requestAll.postRequest('/api/Content/contact', data);
	},
	//在线留言	
	online(data) {
	    return requestAll.postRequest('/api/Content/online', data);
	},
	//SEO	
	getSeo(data) {
		return requestAll.postRequest('/api/Content/getSeo', data);
	},
	//收集邮箱
	email(data) {
	    return requestAll.postRequest('/api/Content/email', data);
	},
	//vr列表
	vrList(data) {
	    return requestAll.postRequest('/api/Content/vrList', data);
	},
	//文件下载 密码验证
	productPassword(data) {
	    return requestAll.postRequest('/api/Content/productPassword', data);
	},


}

export default api
